export const AccountPurpose = [
  'CharitableDonations',
  'EcommerceRetailPayments',
  'InvestmentPurposes',
  'Other',
  'PaymentsToFriendsOrFamilyAbroad',
  'Payroll',
  'PersonalOrLivingExpenses',
  'ProtectWealth',
  'PurchaseGoodsAndServices',
  'ReceivePaymentsForGoodsAndServices',
  'TaxOptimization',
  'ThirdPartyMoneyTransmission',
  'TreasuryManagement'
]

export const SourceOfFunds = [
  'BusinessLoans',
  'Grants',
  'InterCompanyFunds',
  'InvestmentProceeds',
  'LegalSettlement',
  'OwnersCapital',
  'PensionRetirement',
  'SaleOfAssets',
  'SalesOfGoodsAndServices',
  'ThirdPartyFunds',
  'TreasuryReserves'
]

export const CryptoAccountActivity = [
  'Receive Crypto Payments',
  'Make Crypto Payouts',
  'Receive Settlements',
  'Treasury Management',
  'Deposit Crypto'
]

export const FiatAccountActivity = [
  'InvestmentPurposes',
  'Payroll',
  'PersonalOrLivingExpenses',
  'ProtectWealth',
  'PurchaseGoodsAndServices',
  'ReceivePaymentsForGoodsAndServices',
  'TaxOptimization',
  'TreasuryManagement',
  'Other'
]
